import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39a09410"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "progress-container" }
const _hoisted_2 = {
  class: "progress",
  role: "progressbar"
}
const _hoisted_3 = ["title", "data-testid"]
const _hoisted_4 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`progress-label`),
  "data-testid": "label"
}
const _hoisted_5 = {
  class: /*#__PURE__*/_normalizeClass('progress-label-value')
}
const _hoisted_6 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`progress-label-unit`),
  "data-testid": "unit"
}
const _hoisted_7 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(`progress-label`),
  "data-testid": "label"
}
const _hoisted_8 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`progress-label-unit`),
  "data-testid": "unit"
}

export type Progress = {
  value: number
  color?: string
  title?: string
}

type LabelPosition = 'left' | 'right'

type Props = {
  data?: Progress[]
  label?: string
  unit?: string
  labelPosition?: LabelPosition
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Progress',
  props: {
    data: {},
    label: {},
    unit: {},
    labelPosition: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, ({ value, color, title }, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "progress-value",
          key: index,
          title: title,
          style: _normalizeStyle({
          width: value + '%',
          backgroundColor: color ? color : 'var(--neutral-90)',
        }),
          "data-testid": `value-${index}`
        }, null, 12 /* STYLE, PROPS */, _hoisted_3))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(`progress-labels ${_ctx.labelPosition}`),
      "data-testid": "progress-labels"
    }, [
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.label), 1 /* TEXT */),
            (_ctx.unit)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.unit), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _renderSlot(_ctx.$slots, "default"),
            (_ctx.unit)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.unit), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]))
    ], 2 /* CLASS */)
  ]))
}
}

})